import { useSessionStore } from '@/stores/SessionStore.ts';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';
import { ProfileConfigService } from '@/services/config/ProfileConfigService.ts';

export const selectedProfileToggleAction = async () => {
    const settingsStore = useSettingsStore();

    const profileIds = settingsStore.favoriteProfileIds;

    if (profileIds.length === 0) {
        createTextToast(
            'No favorited profiles found',
            'Visit the edit overview (Profile dropdown -> Edit promps) to favorite profiles.',
            'destructive',
            true,
        );

        return;
    }

    const sessionStore = useSessionStore();

    const nextProfileConfigId = profileIds[sessionStore.dynamicProfileIndex % profileIds.length];

    const profileConfig = ProfileConfigService.getProfileConfig(nextProfileConfigId);
    if (!profileConfig) {
        createTextToast(`Failed to find next profile`, undefined, 'destructive', true);
    }

    settingsStore.selectedProfileId = profileConfig.id;

    let toastDescription = `"${profileConfig.name}" profile is now active.`;
    if (profileIds.length === 1) {
        toastDescription += ' Only 1 favorited profile found.';
    }

    createTextToast('Selected profile updated', toastDescription, 'success', true);

    sessionStore.dynamicProfileIndex = sessionStore.dynamicProfileIndex + 1;
};
